import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Col from "@visa/vds/col";
import Divider from "@visa/vds/divider";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import MCSLoading from "../../../components/MCSLoading";
import MCSOverlayLoading from "../../../components/MCSOverlayLoading";
import MCSSpace from "../../../components/MCSSpace";
import { AuthContext } from "../../../context/AuthContext";
import { GlobalAlertContext } from "../../../context/GlobalAlertContext";
import { adminService } from "../../../services/admin.service";
import { AdminRoutes } from "../../../_constants/PageRoutes";
import { ObjectMapHelper } from "../../../_helpers/ObjectMapHelper";
import { updateOrganizationDto } from "../../../_mappings/Organization";
import BillingDataSection from "./BillingDataSection";
import CompanyInfoSection from "./CompanyInfoSection";

function ManageOrganizationDetails() {
  const location = useLocation();
  const history = useHistory();
  const [countries, setCountries] = useState(null);
  const [organizationDetail, setOrganizationDetail] = useState(null);
  const [fetching, setFetching] = useState(false);

  const GetAllCountries = async () => {
    const response = await adminService.GetAllCountries();
    setCountries(response.result);
  };

  const returnToOrganizationPage = () => {
    history.push(AdminRoutes.MANAGEORGANIZATIONS);
  };

  const UpdateOrganizationDetails = async (alertObj) => {
    let updateDto = ObjectMapHelper.MapDto(organizationDetail, updateOrganizationDto);

    const Response = await adminService.UpdateOrganization(
      organizationDetail.id,
      updateDto
    );
    if (Response) {
      alertObj.setSuccessMessage("Organization successfully updated");
    } else {
      alertObj.setErrorMessage("Organization failed to be updated");
    }
    setFetching(false);
    returnToOrganizationPage();
  };

  React.useEffect(() => {
    GetAllCountries();
    setOrganizationDetail(location.state.organization);
  }, []);

  if (organizationDetail == null) {
    return <MCSLoading />;
  } else {
    return (
      <AuthContext.Consumer>
        {(data) => (
          <GlobalAlertContext.Consumer>
            {(alertObj) => (
              <>
                {fetching && <MCSOverlayLoading />}
                <Grid>
                  <Row>
                    <Col>
                      <Typography tag="h1">Organization Details</Typography>
                      <Divider type="standard" />

                      <Row>
                        <Col>
                          <ButtonGroup direction="right">
                            <ButtonText
                              colorScheme="secondary"
                              onClick={returnToOrganizationPage}
                            >
                              Cancel
                            </ButtonText>
                            <ButtonText
                              colorScheme="primary"
                              onClick={() =>
                                UpdateOrganizationDetails(alertObj)
                              }
                            >
                              Save Changes
                            </ButtonText>
                          </ButtonGroup>
                        </Col>
                      </Row>
                      <CompanyInfoSection
                        user={data.user}
                        countries={countries}
                        organization={organizationDetail}
                        setOrganization={setOrganizationDetail}
                      />
                      <BillingDataSection
                        organization={organizationDetail}
                        setOrganization={setOrganizationDetail}
                      />
                      {/* <ContactsDataSection
                        countries={countries}
                        organization={organizationDetail}
                        setOrganization={setOrganizationDetail}
                      /> */}
                    </Col>
                  </Row>
                  <MCSSpace />

                  <Row>
                    <Col>
                      <ButtonGroup direction="right">
                        <ButtonText
                          colorScheme="secondary"
                          onClick={returnToOrganizationPage}
                        >
                          Cancel
                        </ButtonText>
                        <ButtonText
                          colorScheme="primary"
                          onClick={() => UpdateOrganizationDetails(alertObj)}
                        >
                          Save Changes
                        </ButtonText>
                      </ButtonGroup>
                    </Col>
                  </Row>
                </Grid>
              </>
            )}
          </GlobalAlertContext.Consumer>
        )}
      </AuthContext.Consumer>
    );
  }
}

export default ManageOrganizationDetails;
